module.exports = __webpack_public_path__ + "static/img/certificate2.7c11e07d.png";